export class DialogModelConfirmSession {
    constructor(
        public response: any
    ) { }
}